export function handle(input) {
    const prefix = input.dataset.linkInput;

    input.addEventListener("focus", () => {
        if (!input.value) {
            input.value = prefix;
        }
    });

    input.addEventListener("blur", () => {
        if (input.value.trim() === prefix) {
            input.value = "";
        }
    });
}

export function handleAll() {
    document.querySelectorAll("[data-link-input]")
        .forEach(handle);
}
